import { IconProps } from '../icon-props-interface';
import '../icons.scss';


const IconDisconnect = ({ color = 'var(--color-primary-3)' }: IconProps): JSX.Element => (
    <div className="icon-block">
        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M0.999999 6L3.21414 6C3.21414 5.87929 3.30277 4.91478 3.5 4.5L10 11.9993L7.5 12C6.5 12.0007 5.37185 11.3473 5 11C3.99996 10.0661 3.21414 8.5 3.21414 8.5L0.999999 8.5C0.447715 8.5 -1.55275e-07 8.05228 -1.31134e-07 7.5L-1.09278e-07 7C-8.51374e-08 6.44772 0.447715 6 0.999999 6Z" fill="#181823"/>
            <path d="M11.7713 2L11.7713 3.70972L14.4108 3.70972C14.4108 3.70972 14.9495 3.97394 14.9974 4.56458C15.0453 5.15522 14.4108 5.41944 14.4108 5.41944L11.7713 5.41944L11.7713 8.1265L14.4108 8.1265C14.4108 8.1265 14.9495 8.3527 14.9974 8.98136C15.0453 9.61002 14.4108 9.83622 14.4108 9.83622L11.7713 9.83622L11.7713 11.7426C11.7713 12.2774 11 11 10.5 10.5L4.5 3.5C5 2.5 6.5 1.99999 7.19947 2L10.2484 2L11.7713 2Z" fill="#181823"/>
            <path d="M1.5 1.5L12 14" stroke="#181823" strokeLinecap="round"/>
        </svg>
    </div>
);

export default IconDisconnect;
